export default __webpack_public_path__ + "static/media/SliderBtnLarg.e1648f0e.png";